import { render, staticRenderFns } from "./HeaderSecondTabs.vue?vue&type=template&id=1c2b0c44&scoped=true"
import script from "./HeaderSecondTabs.vue?vue&type=script&lang=js"
export * from "./HeaderSecondTabs.vue?vue&type=script&lang=js"
import style0 from "./HeaderSecondTabs.vue?vue&type=style&index=0&id=1c2b0c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b0c44",
  null
  
)

export default component.exports